import { login, logout, getUserInfo } from "@/api/login";
import { getToken, setToken, removeToken } from "@/utils/auth";

const user = {
  state: {
    user: "",
    email: "",
    token: getToken(),
    name: "",
    setting:{},
    defaultbranch: {
      id: "",
      branchName: ""
    },
    loggedOut: false,
    topBarShow:false,
    bottomNavShow:false,
    snackbarText:"",
    profileCompleted:true,
    personalInfo:{}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction;
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_LOGGEDOUT: (state, loggedOut) => {
      state.loggedOut = loggedOut;
    },
    SET_EMAIL: (state, email) => {
      state.email = email;
    },
    SET_DEFAULT_BRANCH: (state, defaultbranch) => {
      state.defaultbranch = defaultbranch;
    },
    SET_TOPBARSHOW: (state, topBarShow) => {
      state.topBarShow = topBarShow;
    },
    SET_BOTTOMNAVSHOW:(state,bottomNavShow)=>{
      state.bottomNavShow = bottomNavShow;
    },
    PROFILE_COMPLETED:(state,profileCompleted)=>{
      state.profileCompleted = profileCompleted;
    },
    SET_PERSONALINFO: (state,personalInfo)=>{
      state.personalInfo = personalInfo;
    },
    SET_SNACKBARTEXT: (state,snackbarText)=>{
      state.snackbarText = snackbarText;
    }
  },

  actions: {
    // login
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim();
      return new Promise((resolve, reject) => {
        login(username, userInfo.password)
          .then(response => {
            commit("SET_TOKEN", response.data.data.token);
            removeToken("Admin-Token");
            setToken(response.data.data.token);
            commit("SET_LOGGEDOUT", false);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // get current user
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then(response => {
            if (!response.data) {
              reject("Verification failed, please login again.");
            }
            const data = response.data.data;

            commit("SET_NAME", data.userName);
            commit("SET_EMAIL", data.email);
            resolve();
            // resolve(response)
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // log out
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit("SET_TOKEN", "");
            removeToken();
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
  }
};

export default user;
